function o(t) {
  return function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = e.width ? String(e.width) : t.defaultWidth, n = t.formats[a] || t.formats[t.defaultWidth];
    return n;
  };
}
function b(t) {
  return function(e, a) {
    var n = a != null && a.context ? String(a.context) : "standalone", l;
    if (n === "formatting" && t.formattingValues) {
      var u = t.defaultFormattingWidth || t.defaultWidth, r = a != null && a.width ? String(a.width) : u;
      l = t.formattingValues[r] || t.formattingValues[u];
    } else {
      var i = t.defaultWidth, v = a != null && a.width ? String(a.width) : t.defaultWidth;
      l = t.values[v] || t.values[i];
    }
    var d = t.argumentCallback ? t.argumentCallback(e) : e;
    return l[d];
  };
}
function s(t) {
  return function(e) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = a.width, l = n && t.matchPatterns[n] || t.matchPatterns[t.defaultMatchWidth], u = e.match(l);
    if (!u)
      return null;
    var r = u[0], i = n && t.parsePatterns[n] || t.parsePatterns[t.defaultParseWidth], v = Array.isArray(i) ? m(i, function(c) {
      return c.test(r);
    }) : h(i, function(c) {
      return c.test(r);
    }), d;
    d = t.valueCallback ? t.valueCallback(v) : v, d = a.valueCallback ? a.valueCallback(d) : d;
    var f = e.slice(r.length);
    return {
      value: d,
      rest: f
    };
  };
}
function h(t, e) {
  for (var a in t)
    if (t.hasOwnProperty(a) && e(t[a]))
      return a;
}
function m(t, e) {
  for (var a = 0; a < t.length; a++)
    if (e(t[a]))
      return a;
}
function P(t) {
  return function(e) {
    var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = e.match(t.matchPattern);
    if (!n)
      return null;
    var l = n[0], u = e.match(t.parsePattern);
    if (!u)
      return null;
    var r = t.valueCallback ? t.valueCallback(u[0]) : u[0];
    r = a.valueCallback ? a.valueCallback(r) : r;
    var i = e.slice(l.length);
    return {
      value: r,
      rest: i
    };
  };
}
export {
  b as a,
  o as b,
  P as c,
  s as d
};
//# sourceMappingURL=index-becfb567.mjs.map
